"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.concatUint8Array = void 0;
function concatUint8Array() {
    var chunks = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        chunks[_i] = arguments[_i];
    }
    // if(!Array.isArray(chunks)) return new Uint8Array([]);
    if (!chunks.every(function (chunk) { return chunk instanceof Uint8Array; }))
        return new Uint8Array([]);
    if (chunks.length <= 0)
        return new Uint8Array([]);
    if (chunks.length === 1)
        return Uint8Array.prototype.slice.call(chunks[0]);
    var len = chunks.reduce(function (acc, chunk) { return acc + chunk.length; }, 0);
    var result = new Uint8Array(len);
    var offset = 0;
    var nChunks = chunks.length;
    for (var i = 0, chunk = void 0; i < nChunks;) {
        chunk = chunks[i++];
        result.set(chunk, offset);
        offset += chunk.length;
    }
    return result;
}
exports.concatUint8Array = concatUint8Array;
